export interface IFilterableListResultsDto {
    searchItemList: IFilterableListSearchResultItem[];
    facets: IFilterableListFacet[];
    totalNumber: number;
    totalPages: number;
    allowedSortFields: string[];
    columnNames: string[];
    columnOrder: string[];
}

export interface IFilterableListSearchResultItem {
    rowDictionary: Object;
}

export interface IFilterableListFacet {
    name: string;
    terms: IFilterableListFacetTerm[];
    renderTemplate: number;
    fieldName: string;
}


export interface IFilterableListFacetTerm {
    displayTerm: string;
    term: string;
    hits: number;
    fieldName: string;
    id: number;
    selected: boolean;
    alwaysShow: boolean;
    from: string;
    to: string;
    description: string;
}

export const DefaultFilterableListResults = {
    results: null,
    uniqueUserId: "",
    getResultsAsyncCaller: '',
}


export interface IFilterableListCriteria {
    pageId: number;
    searchTerm: string;
    pageSize: number;
    page: number;
    facets: IFilterableListFacet[];
    sortField: string;
    sortDirection: number;
    allowedSortFields: string[];
}

export interface INameAndEmailRequest {
    name: string;
    email: string;
}
